// src/services/representantesService.js
import { getAuthHeader } from "./authService";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/v1/representantes`;

// Helpers de respuesta
const toJson = (res) => res.json().catch(() => ({}));
const ensureOk = (res, data) => {
  if (!res.ok) {
    const msg =
      data?.message ||
      data?.error ||
      (typeof data === "string" ? data : "") ||
      `HTTP ${res.status}`;
    throw new Error(msg);
  }
};
const clean = (obj) => {
  const out = {};
  Object.entries(obj || {}).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    if (typeof v === "string" && v.trim() === "") return;
    out[k] = v;
  });
  return out;
};

/**
 * GET representantes por institución
 * http://localhost:3001/api/v1/representantes/:institucion_id
 */
export async function listRepresentantes(institutionId) {
  const res = await fetch(
    `${BASE_URL}/${institutionId}`,
    { headers: { Accept: "application/json", ...getAuthHeader() } }
  );
  const data = await toJson(res);
  ensureOk(res, data);
  // La API retorna { status, message, data: [...] }
  return data?.data ?? [];
}

/**
 * POST crear representante
 * http://localhost:3000/api/v1/representantes/:institucion_id
 */
export async function createRepresentante(institutionId, form) {
  const payload = clean({
    email: form.email,
    password: form.password, // requerido al crear
    nombres: form.nombres,
    apellidos: form.apellidos,
    telefono: form.telefono,
    institucion_id: institutionId,
    rol_id: form.rol_id,
    cedula: form.cedula,
    fecha_nacimiento: form.fecha_nacimiento, // YYYY-MM-DD
    direccion: form.direccion,
  });

  const res = await fetch(
    `${BASE_URL}/${institutionId}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...getAuthHeader(), // siempre Bearer
      },
      body: JSON.stringify(payload),
    }
  );
  const data = await toJson(res);
  ensureOk(res, data);
  return data?.data ?? data;
}

/**
 * PUT actualizar representante
 * http://localhost:3000/api/v1/representantes/:representante_id
 */
export async function updateRepresentante(id, form) {
  const payload = clean({
    email: form.email,
    nombres: form.nombres,
    apellidos: form.apellidos,
    telefono: form.telefono,
    rol_id: form.rol_id,
    cedula: form.cedula,
    fecha_nacimiento: form.fecha_nacimiento,
    direccion: form.direccion,
    // password: form.password, // si luego permites cambio de contraseña
  });

  const res = await fetch(
    `${BASE_URL}/${id}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...getAuthHeader(),
      },
      body: JSON.stringify(payload),
    }
  );
  const data = await toJson(res);
  ensureOk(res, data);
  return data?.data ?? data;
}

/**
 * DELETE eliminar representante
 * http://localhost:3000/api/v1/representantes/:representante_id
 */
export async function deleteRepresentante(id) {
  const res = await fetch(
    `${BASE_URL}/${id}`,
    {
      method: "DELETE",
      headers: { Accept: "application/json", ...getAuthHeader() },
    }
  );
  const data = await toJson(res);
  ensureOk(res, data);
  return true;
}

export async function authorizeRepresentante(id, authorized) {
  const payload = { authorized };

  const res = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/api/v1/users/authorize/${id}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...getAuthHeader(),
      },
      body: JSON.stringify(payload),
    }
  );

  const data = await toJson(res);
  ensureOk(res, data);
  return data?.data ?? data;
}